var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.status)?_c('Badge',{staticClass:"shops-signer-status__label",attrs:{"value":[_vm.statusLabel, _vm.additionalMessage].filter(Boolean).join(' · '),"type":"outlined","theme":_vm.theme,"icon":_vm.icon}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }